import styled, { css } from "styled-components";

export default function ProductCard(props) {
    const {
        archived,
        bimClassName,
        bimClassType,
        brandName,
        countries,
        name,
        ...restProps
    } = props;

    return (
        <Styled
            $archived={archived}
            as={props.href ? "a" : props.onClick ? "button" : "div"}
            {...restProps}
        >
            <span className="brand">{brandName}</span>
            <span className="name">
                {name ?? "[THIS PRODUCT DOES NOT HAVE A NAME]"}
                {archived && <span className="archived-label">[ARCHIVED]</span>}
            </span>
            <span className="bimclass">
                <span className="name">{bimClassName}</span>
                <span className="type">{bimClassType}</span>
            </span>
            <span className="countries">
                {countries?.map?.((country) => <span key={country}>{country}</span>) ?? [
                    "ALL",
                ]}
            </span>
        </Styled>
    );
}

const Styled = styled.button<{ $archived?: boolean }>`
    align-items: flex-start;
    background: transparent;
    color: ${({ $archived }) => ($archived ? "#d00" : "#000")};
    border: 1px solid transparent;
    border-radius: 2px;
    cursor: default;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 24px 8px 16px;
    transition: 200ms;

    .brand {
        font-size: 1em;
    }

    & > .name {
        font-size: 1.6em;

        .archived-label {
            color: #d00;
            font-family: var(--font-sans), sans-serif;
            font-size: 0.6em;
            font-weight: bold;
            margin-left: 8px;
            vertical-align: middle;
        }
    }

    .bimclass {
        font-family: var(--font-mono), monospace;
        font-size: 0.8em;
        letter-spacing: -0.04em;

        .type {
            &::after {
                content: "]";
            }

            &::before {
                content: " [";
            }

            &:empty {
                display: none;
            }
        }
    }

    .countries {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        font-size: 1em;
        gap: 2px;

        &:empty {
            display: none;
        }

        & > span {
            background: #eee4;
            border: 1px solid #eee;
            border-radius: 3px;
            padding: 1px 3px;
            white-space: nowrap;
        }
    }

    ${({ onClick, href }) => (onClick || href) && CSSClickable}
`;

const CSSClickable = css`
    cursor: pointer;

    &:hover {
        & > .name {
            text-decoration: underline;
        }
    }
`;
